export const TEACHER_INSTRUCTIONAL_PERIODS = [
  {
    day: 'monday',
    periods: [
      {
        end: '2023-07-03T03:00:00.000Z',
        start: '2023-07-31T01:30:00.000Z',
        title: 'Homeroom',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T03:00:00.000Z',
        title: 'Period 1',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T05:00:00.000Z',
        start: '2023-07-03T04:00:00.000Z',
        title: 'Period 2',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T06:00:00.000Z',
        start: '2023-07-03T05:00:00.000Z',
        title: 'Period 3',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T07:00:00.000Z',
        start: '2023-07-03T06:00:00.000Z',
        title: 'Period 4',
        subject: 'Geometry',
        grade: '6th',
      },
    ],
  },
  {
    day: 'tuesday',
    periods: [
      {
        end: '2023-07-03T03:00:00.000Z',
        start: '2023-07-31T01:30:00.000Z',
        title: 'Homeroom',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T03:00:00.000Z',
        title: 'Period 1',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T05:00:00.000Z',
        start: '2023-07-03T04:00:00.000Z',
        title: 'Period 2',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T06:00:00.000Z',
        start: '2023-07-03T05:00:00.000Z',
        title: 'Period 3',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T07:00:00.000Z',
        start: '2023-07-03T06:00:00.000Z',
        title: 'Period 4',
        subject: 'Geometry',
        grade: '6th',
      },
    ],
  },
  {
    day: 'wednesday',
    periods: [
      {
        end: '2023-07-03T03:00:00.000Z',
        start: '2023-07-31T01:30:00.000Z',
        title: 'Homeroom',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T03:00:00.000Z',
        title: 'Period 1',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T05:00:00.000Z',
        start: '2023-07-03T04:00:00.000Z',
        title: 'Period 2',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T06:00:00.000Z',
        start: '2023-07-03T05:00:00.000Z',
        title: 'Period 3',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T07:00:00.000Z',
        start: '2023-07-03T06:00:00.000Z',
        title: 'Period 4',
        subject: 'Geometry',
        grade: '6th',
      },
    ],
  },
  {
    day: 'thursday',
    periods: [
      {
        end: '2023-07-03T03:00:00.000Z',
        start: '2023-07-31T01:30:00.000Z',
        title: 'Homeroom',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T03:00:00.000Z',
        title: 'Period 1',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T05:00:00.000Z',
        start: '2023-07-03T04:00:00.000Z',
        title: 'Period 2',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T06:00:00.000Z',
        start: '2023-07-03T05:00:00.000Z',
        title: 'Period 3',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T07:00:00.000Z',
        start: '2023-07-03T06:00:00.000Z',
        title: 'Period 4',
        subject: 'Geometry',
        grade: '6th',
      },
    ],
  },
  {
    day: 'friday',
    periods: [
      {
        end: '2023-07-03T03:00:00.000Z',
        start: '2023-07-31T01:30:00.000Z',
        title: 'Homeroom',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T03:00:00.000Z',
        title: 'Period 1',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T05:00:00.000Z',
        start: '2023-07-03T04:00:00.000Z',
        title: 'Period 2',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T04:00:00.000Z',
        start: '2023-07-03T05:00:00.000Z',
        title: 'Period 3',
        subject: 'Geometry',
        grade: '6th',
      },
      {
        end: '2023-09-26T07:00:00.000Z',
        start: '2023-07-03T06:00:00.000Z',
        title: 'Period 4',
        subject: 'Geometry',
        grade: '6th',
      },
    ],
  },
];

export const TEACHER_SUBJECT_HOURS = [
  {
    id: 1665,
    created_at: 1693483497591,
    user_id: 235,
    subject_id: 2,
    grades_id: 1,
    day: 'wednesday',
    start: 1688409000000,
    end: 1688412600000,
    peroid: 'period 4',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 2,
      created_at: 1667470489179,
      subject: 'Algebra II',
    },
    grades: {
      id: 1,
      created_at: 1667469749917,
      grade: '6th',
    },
  },
  {
    id: 1666,
    created_at: 1693483497596,
    user_id: 235,
    subject_id: 2,
    grades_id: 1,
    day: 'thursday',
    start: 1688409000000,
    end: 1688412600000,
    peroid: 'period 4',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 2,
      created_at: 1667470489179,
      subject: 'Algebra II',
    },
    grades: {
      id: 1,
      created_at: 1667469749917,
      grade: '6th',
    },
  },
  {
    id: 1667,
    created_at: 1693483497606,
    user_id: 235,
    subject_id: 2,
    grades_id: 1,
    day: 'friday',
    start: 1688409000000,
    end: 1688412600000,
    peroid: 'period 4',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 2,
      created_at: 1667470489179,
      subject: 'Algebra II',
    },
    grades: {
      id: 1,
      created_at: 1667469749917,
      grade: '6th',
    },
  },
  {
    id: 1027,
    created_at: 1691056227774,
    user_id: 235,
    subject_id: 1,
    grades_id: 7,
    day: 'monday',
    start: 1688396400000,
    end: 1688400000000,
    peroid: 'period 1',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 1,
      created_at: 1667470488260,
      subject: 'Algebra I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1030,
    created_at: 1691056227792,
    user_id: 235,
    subject_id: 1,
    grades_id: 7,
    day: 'thursday',
    start: 1688396400000,
    end: 1688400000000,
    peroid: 'period 1',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 1,
      created_at: 1667470488260,
      subject: 'Algebra I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1031,
    created_at: 1691056227796,
    user_id: 235,
    subject_id: 1,
    grades_id: 7,
    day: 'friday',
    start: 1688396400000,
    end: 1688400000000,
    peroid: 'period 1',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 1,
      created_at: 1667470488260,
      subject: 'Algebra I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1028,
    created_at: 1691056227785,
    user_id: 235,
    subject_id: 2,
    grades_id: 7,
    day: 'tuesday',
    start: 1688396400000,
    end: 1688400000000,
    peroid: 'period 1',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 2,
      created_at: 1667470489179,
      subject: 'Algebra II',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1074,
    created_at: 1691062464059,
    user_id: 235,
    subject_id: 25,
    grades_id: 2,
    day: 'wednesday',
    start: 1688396400000,
    end: 1688400000000,
    peroid: 'period 1',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 25,
      created_at: 1687333515124,
      subject: 'Pre-Algebra',
    },
    grades: {
      id: 2,
      created_at: 1667469757244,
      grade: '5th',
    },
  },
  {
    id: 1512,
    created_at: 1692855430757,
    user_id: 235,
    subject_id: 5,
    grades_id: 7,
    day: 'monday',
    start: 1688400000000,
    end: 1688403600000,
    peroid: 'period 2',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 5,
      created_at: 1667470492439,
      subject: 'Math I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1513,
    created_at: 1692855430766,
    user_id: 235,
    subject_id: 5,
    grades_id: 7,
    day: 'tuesday',
    start: 1688400000000,
    end: 1688403600000,
    peroid: 'period 2',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 5,
      created_at: 1667470492439,
      subject: 'Math I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1514,
    created_at: 1692855430770,
    user_id: 235,
    subject_id: 5,
    grades_id: 7,
    day: 'wednesday',
    start: 1688400000000,
    end: 1688403600000,
    peroid: 'period 2',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 5,
      created_at: 1667470492439,
      subject: 'Math I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1515,
    created_at: 1692855430774,
    user_id: 235,
    subject_id: 5,
    grades_id: 7,
    day: 'thursday',
    start: 1688400000000,
    end: 1688403600000,
    peroid: 'period 2',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 5,
      created_at: 1667470492439,
      subject: 'Math I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
  {
    id: 1516,
    created_at: 1692855430777,
    user_id: 235,
    subject_id: 5,
    grades_id: 7,
    day: 'friday',
    start: 1688400000000,
    end: 1688403600000,
    peroid: 'period 2',
    school_bell_shedules_id: 0,
    dummy_users_id: 0,
    subject: {
      id: 5,
      created_at: 1667470492439,
      subject: 'Math I',
    },
    grades: {
      id: 7,
      created_at: 1667469798924,
      grade: '5th',
    },
  },
];

export const TEACHER_NAME_LIST = [
  {
    id: 3832,
    created_at: 1707229366000,
    firstName: 'Justin',
    lastName: 'Yamini',
    email: 'justin@techmethere.com',
    school_indentity_number: 'asdf234',
    role_id: 9,
    school_id: 96,
    isNewUser: false,
    profileData: {
      dateOfHire: 1707552000000,
      currentRoute: '/administration',
      tbClearanceDate: 1706774400000,
      tbExpirationDate: 1833004800000,
      credentialDocumentNumber: 'asdf',
      credentialExpirationDate: 1716620400000,
      credentialTypeEmployment: 'asdf',
      dateOfCriminalBackground: 1700121600000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 5,
      teachingGrades: [8, 9, 10, 11],
      teachingSubject: [1, 2, 24, 27, 21, 20],
      teachingSubjectcount: 6,
    },
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: 163321200000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 96,
      created_at: 1707251221670,
      name: 'International Academy Trial School',
      city: 'California',
      state: 'London',
      country: 'United States',
      code: 'DFqyMToAU',
      phone: 1235551194,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: 1679586240000,
              start: 1679584200000,
              title: 'Period 1',
            },
            {
              end: 1679588460000,
              start: 1679586420000,
              title: 'Period 2',
            },
            {
              end: 1679589240000,
              start: 1679588640000,
              title: 'Homeroom',
            },
            {
              end: 1679590200000,
              start: 1679589240000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679592420000,
              start: 1679590380000,
              title: 'Period 3',
            },
            {
              end: 1679594640000,
              start: 1679592600000,
              title: 'Period 4',
            },
            {
              end: 1679595420000,
              start: 1679594640000,
              title: 'Snack/Nutrition II',
            },
            {
              end: 1679597640000,
              start: 1679595600000,
              title: 'Period 5',
            },
            {
              end: 1679599860000,
              start: 1679597820000,
              title: 'Period 6',
            },
            {
              end: 1679602200000,
              start: 1679600040000,
              title: 'Period 7',
            },
          ],
        },
      ],
      start_time: 1707231600000,
      end_time: 1707256800000,
      start_date: 1706819405000,
      end_date: 1740774612000,
      isNew: true,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 0,
      isSchoolOnboarded: false,
      user_limitations: '',
      is_trial_school: true,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3819,
    created_at: 1706993499000,
    firstName: 'John',
    lastName: 'Francis',
    email: 'john.fr@gmail.com',
    school_indentity_number: 'demo239',
    role_id: 9,
    school_id: 96,
    isNewUser: true,
    profileData: {
      dateOfHire: 1707724800000,
      currentRoute: '/administration/teacher-profile',
      tbClearanceDate: 1675756800000,
      tbExpirationDate: 1801987200000,
      credentialDocumentNumber: '66776',
      credentialExpirationDate: 1707206400000,
      credentialTypeEmployment: 'Teacher',
      dateOfCriminalBackground: 1706860800000,
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 10,
      teachingGrades: [8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [
        8, 7, 6, 5, 1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15, 18, 19, 20, 21, 22,
        23, 24, 25, 26, 27,
      ],
      teachingSubjectcount: 25,
    },
    user_profile_media_id: 0,
    contact: 8888888888,
    address: '',
    birthdate: 1580803200000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: true,
    school: {
      id: 96,
      created_at: 1707251221670,
      name: 'International Academy Trial School',
      city: 'California',
      state: 'London',
      country: 'United States',
      code: 'DFqyMToAU',
      phone: 1235551194,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: 1679586240000,
              start: 1679584200000,
              title: 'Period 1',
            },
            {
              end: 1679588460000,
              start: 1679586420000,
              title: 'Period 2',
            },
            {
              end: 1679589240000,
              start: 1679588640000,
              title: 'Homeroom',
            },
            {
              end: 1679590200000,
              start: 1679589240000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679592420000,
              start: 1679590380000,
              title: 'Period 3',
            },
            {
              end: 1679594640000,
              start: 1679592600000,
              title: 'Period 4',
            },
            {
              end: 1679595420000,
              start: 1679594640000,
              title: 'Snack/Nutrition II',
            },
            {
              end: 1679597640000,
              start: 1679595600000,
              title: 'Period 5',
            },
            {
              end: 1679599860000,
              start: 1679597820000,
              title: 'Period 6',
            },
            {
              end: 1679602200000,
              start: 1679600040000,
              title: 'Period 7',
            },
          ],
        },
      ],
      start_time: 1707231600000,
      end_time: 1707256800000,
      start_date: 1706819405000,
      end_date: 1740774612000,
      isNew: true,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 0,
      isSchoolOnboarded: false,
      user_limitations: '',
      is_trial_school: true,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 3836,
    created_at: 1707729438627,
    firstName: 'Rushikesh',
    lastName: 'Londhe',
    email: 'rushikesh.l@applicationnexus.com',
    school_indentity_number: '',
    role_id: 9,
    school_id: 96,
    isNewUser: true,
    profileData: {
      currentRoute: '/administration',
    },
    teachingInfo: '',
    user_profile_media_id: 0,
    contact: 0,
    address: '',
    birthdate: null,
    isDisable: false,
    is_logged_in: true,
    is_trial_user: true,
    school: {
      id: 96,
      created_at: 1707251221670,
      name: 'International Academy Trial School',
      city: 'California',
      state: 'London',
      country: 'United States',
      code: 'DFqyMToAU',
      phone: 1235551194,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: 1679586240000,
              start: 1679584200000,
              title: 'Period 1',
            },
            {
              end: 1679588460000,
              start: 1679586420000,
              title: 'Period 2',
            },
            {
              end: 1679589240000,
              start: 1679588640000,
              title: 'Homeroom',
            },
            {
              end: 1679590200000,
              start: 1679589240000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679592420000,
              start: 1679590380000,
              title: 'Period 3',
            },
            {
              end: 1679594640000,
              start: 1679592600000,
              title: 'Period 4',
            },
            {
              end: 1679595420000,
              start: 1679594640000,
              title: 'Snack/Nutrition II',
            },
            {
              end: 1679597640000,
              start: 1679595600000,
              title: 'Period 5',
            },
            {
              end: 1679599860000,
              start: 1679597820000,
              title: 'Period 6',
            },
            {
              end: 1679602200000,
              start: 1679600040000,
              title: 'Period 7',
            },
          ],
        },
      ],
      start_time: 1707231600000,
      end_time: 1707256800000,
      start_date: 1706819405000,
      end_date: 1740774612000,
      isNew: true,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 0,
      isSchoolOnboarded: false,
      user_limitations: '',
      is_trial_school: true,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },
  {
    id: 2,
    created_at: 1667470367762,
    firstName: 'John',
    lastName: 'Francis',
    email: 'respondedutrial.teacher@gmail.com',
    school_indentity_number: 'demo239',
    role_id: 9,
    school_id: 96,
    isNewUser: false,
    profileData: {
      dateOfHire: '2023-06-26',
      currentRoute: '/administration/teacher-periods',
      tbClearanceDate: '2023-06-01',
      tbExpirationDate: '2027-06-01',
      credentialDocumentNumber: '222222222',
      credentialExpirationDate: '2028-06-05',
      credentialTypeEmployment: 'Multiple and Single Subject Credentials',
      dateOfCriminalBackground: '2023-06-02',
    },
    teachingInfo: {
      bellShedule: 'true',
      designation: 'Highschool',
      examPerdays: 5,
      teachingGrades: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      teachingSubject: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
      ],
      teachingSubjectcount: 27,
    },
    user_profile_media_id: 0,
    contact: 6578958678,
    address: '3649 Park Ct, Drayton Valley, T0E 0M0, Alberta',
    birthdate: 698677731000,
    isDisable: false,
    is_logged_in: false,
    is_trial_user: null,
    school: {
      id: 96,
      created_at: 1707251221670,
      name: 'International Academy Trial School',
      city: 'California',
      state: 'London',
      country: 'United States',
      code: 'DFqyMToAU',
      phone: 1235551194,
      school_periods: [
        {
          day: 'monday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'tuesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'wednesday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'thursday',
          periods: [
            {
              end: 1679587260000,
              start: 1677168600000,
              title: 'Period 1',
            },
            {
              end: 1679590500000,
              start: 1679587440000,
              title: 'Period 2',
            },
            {
              end: 1679590980000,
              start: 1679590680000,
              title: 'Homeroom',
            },
            {
              end: 1679591880000,
              start: 1679590980000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679595120000,
              start: 1679592060000,
              title: 'Period 3',
            },
            {
              end: 1679598360000,
              start: 1679595300000,
              title: 'Period 4',
            },
            {
              end: 1679600460000,
              start: 1679598360000,
              title: 'Lunch',
            },
            {
              end: 1679603700000,
              start: 1679600640000,
              title: 'Period 5',
            },
            {
              end: 1679606940000,
              start: 1679603880000,
              title: 'Period 6',
            },
            {
              end: 1679610360000,
              start: 1679607120000,
              title: 'Period 7',
            },
          ],
        },
        {
          day: 'friday',
          periods: [
            {
              end: 1679586240000,
              start: 1679584200000,
              title: 'Period 1',
            },
            {
              end: 1679588460000,
              start: 1679586420000,
              title: 'Period 2',
            },
            {
              end: 1679589240000,
              start: 1679588640000,
              title: 'Homeroom',
            },
            {
              end: 1679590200000,
              start: 1679589240000,
              title: 'Snack/Nutrition Break',
            },
            {
              end: 1679592420000,
              start: 1679590380000,
              title: 'Period 3',
            },
            {
              end: 1679594640000,
              start: 1679592600000,
              title: 'Period 4',
            },
            {
              end: 1679595420000,
              start: 1679594640000,
              title: 'Snack/Nutrition II',
            },
            {
              end: 1679597640000,
              start: 1679595600000,
              title: 'Period 5',
            },
            {
              end: 1679599860000,
              start: 1679597820000,
              title: 'Period 6',
            },
            {
              end: 1679602200000,
              start: 1679600040000,
              title: 'Period 7',
            },
          ],
        },
      ],
      start_time: 1707231600000,
      end_time: 1707256800000,
      start_date: 1706819405000,
      end_date: 1740774612000,
      isNew: true,
      limitation_user_number: {
        studentLimit: 2000,
        teacherLimit: 2000,
        otherUserLimit: 2000,
      },
      school_logo_id: 0,
      isSchoolOnboarded: false,
      user_limitations: '',
      is_trial_school: true,
    },
    role: {
      id: 9,
      created_at: 1667469900363,
      name: 'Teacher',
    },
  },

];